import { z } from "zod";
export const rolesSchema = z.union([
    z.literal("Admin"),
    z.literal("Announcements"),
    z.literal("AwardsCeremonyRegistration"),
    z.literal("AwardsSettings"),
    z.literal("AwardsTimeline"),
    z.literal("Campaigns"),
    z.literal("Candidate"),
    z.literal("Categories"),
    z.literal("Contacts"),
    z.literal("Exports"),
    z.literal("FinalizeFinalists"),
    z.literal("FinalizeNominees"),
    z.literal("FinalizeWinners"),
    z.literal("Permissions"),
    z.literal("Products"),
    z.literal("ReconcileClaimedNominations"),
    z.literal("Reports"),
    z.literal("Tags"),
    z.literal("Unauthorized"),
    z.literal("Users"),
    z.literal("Verification"),
]);
export const secondaryRoles = [
    "Announcements",
    "AwardsCeremonyRegistration",
    "AwardsSettings",
    "AwardsTimeline",
    "Campaigns",
    "Categories",
    "Contacts",
    "Exports",
    "FinalizeFinalists",
    "FinalizeNominees",
    "FinalizeWinners",
    "Permissions",
    "Products",
    "ReconcileClaimedNominations",
    "Reports",
    "Tags",
    "Users",
    "Verification",
];
export const roleLabels = {
    Admin: "Admin",
    Announcements: "Announcements",
    AwardsCeremonyRegistration: "Awards Ceremony Registration",
    AwardsSettings: "Awards Settings",
    AwardsTimeline: "Awards Timeline",
    Campaigns: "Campaigns",
    Candidate: "Candidate",
    Categories: "Categories",
    Contacts: "Contacts",
    Exports: "Exports",
    FinalizeFinalists: "Finalize Finalists",
    FinalizeNominees: "Finalize Nominees",
    FinalizeWinners: "Finalize Winners",
    Permissions: "Permissions",
    Products: "Products",
    ReconcileClaimedNominations: "Reconcile Claimed Nominations",
    Reports: "Reports",
    Tags: "Tags",
    Unauthorized: "Unauthorized",
    Users: "Users",
    Verification: "Verification",
};
export const userSchema = z.object({
    awardId: z.string(),
    candidateId: z.string().optional(),
    candidateVerified: z.boolean(),
    email: z.string(),
    enabled: z.boolean(),
    firstName: z.string(),
    lastName: z.string(),
    phone: z.string(),
    role: rolesSchema,
    roles: z.array(rolesSchema),
    stripeCustomerId: z.string().optional(),
    title: z.string(),
    Username: z.string(),
});
// export type User = {
//   awardId: string;
//   candidateId?: string;
//   candidateVerified: boolean;
//   email: string;
//   firstName: string;
//   lastName: string;
//   phone: string;
//   role: Role;
//   roles: Array<Role>;
//   stripeCustomerId?: string;
//   title: string;
//   Username: string;
// };
// export type Role = keyof typeof Roles;
//# sourceMappingURL=types.js.map